import './LoginContainerComponent.css'
import googleIcon from '../../assets/google-icon.png';
import microsoftIcon from '../../assets/microsoft-icon.png';

const LoginExternal = () => {
  // add in logic for redirecting the current page to google for login
  const handleSubmitGoogle = (e) => {
    e.preventDefault();
    console.log('Logging in with Google');
  };  
  // add in logic for redirecting the current page to microsoft for login
  const handleSubmitMicrosoft = (e) => {
    e.preventDefault();
    console.log('Logging in with Microsoft');
  };  
  return (
    <div className="interior-box">
      <div className="divider">
        <hr className="line" />
          <span className="or-text">or</span>
        <hr className="line" />
      </div>
      <button className="my-button" onClick={handleSubmitGoogle}>
        <img src={googleIcon} alt="Google" style={{ height: '20px' }} />
        Sign in with Google
      </button>
      <button className="my-button" onClick={handleSubmitMicrosoft}>
        <img src={microsoftIcon} alt="Microsoft" style={{ height: '20px' }} />
        Sign in with Microsoft
      </button>
    </div>
  );
}

export default LoginExternal;